/**
 *
 * @param func callback function to be throttled
 * @param delay the minimum time in milliseconds that must elapse between two consecutive calls to `func`.
 * @returns closure is returned. This closure checks the time since the last execution of func.
 * If the time since the last execution is greater than or equal to the specified delay,
 * func is called immediately.
 * The actual `func` is called only if the delay has passed since the last execution.
 */
function nextgenThrottle(func: Function, delay: number): Function {
  let inThrottle: boolean;

  return (...args: any[]): void => {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), delay);
    }
  };
}
export { nextgenThrottle };
